<!--页码的公共组件-->
<template>
  <div class="PaginationCom paginationArea" v-show="pageData.total > 0">
    <el-pagination
      background
      layout="total, sizes, prev, pager, next, jumper"
      :page-sizes="pageSizes"
      :page-size="pageData.pageSize"
      :current-page="pageData.currentPage"
      :total="pageData.total"
      @size-change="onPageSizeChange"
      @current-change="onCurrentPageChange">
    </el-pagination>
  </div>
</template>

<script>
  import { PAGINATION } from '@/helpers/baseData';
  
  export default {
    name: 'PaginationCom',
    data () {
      return {
        pageSizes: PAGINATION.pageSizes
      };
    },
    props: {
      pageData: Object
    },
    methods: {
      onPageSizeChange (size) {
        this.$emit('size-change', size);
      },
      
      onCurrentPageChange (page) {
        this.$emit('current-change', page);
      }
    }
  };
</script>

<style lang="scss">
  .PaginationCom {
  }
</style>
